import { Box, Button, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import { Trans, useTranslation } from 'react-i18next'
import { Colors } from '~/libs/mui/theme'
import { DeleteUserResponse } from '~/types/api/withdrawal'
import { getI18nKeys } from './getI18nKeys'

interface WithdrawalCompleteProps {
  user?: DeleteUserResponse
  onClickAppStore: (isIos: boolean) => void
  onClickLogout: () => void
}

export function WithdrawalComplete({
  user,
  onClickAppStore,
}: WithdrawalCompleteProps): JSX.Element {
  const { t } = useTranslation()
  const i18nKeys = getI18nKeys(user?.payment_type)

  return (
    <Box>
      <Box>
        <Typography fontWeight={700} fontSize={{ xs: 16, sm: 20 }}>
          {t('cancellation_completed')}
        </Typography>
        <Typography fontSize={{ sm: 20 }} mt={3}>
          {t('subscription_has_been_canceled')}
          <br />
          {user?.current_period_end_date !== undefined &&
            t('you_can_enjoy_service_until', { date: user.current_period_end_date })}
        </Typography>
      </Box>
      {i18nKeys && (
        <Box border={`1px solid ${Colors.red}`} borderRadius={1} p={2} mt={2} color={Colors.red}>
          <Typography fontWeight={700}>
            <Trans i18nKey={i18nKeys.forAppSubscriptionUsers} />
          </Typography>
          <Typography>
            <Trans i18nKey={i18nKeys.pleaseUnsubscribeFromBelowButton} />
          </Typography>
        </Box>
      )}
      <Stack spacing='10px' mt={{ xs: 2.5, sm: 5 }}>
        {i18nKeys && (
          <Button
            variant='contained'
            onClick={() => {
              onClickAppStore(user?.payment_type === 'ios')
            }}
          >
            {t(i18nKeys.cancelSubscription)}
          </Button>
        )}
        <Box textAlign='center'>
          <Link href='/' passHref style={{ textDecoration: 'none' }}>
            <Button type='button' variant='contained'>
              <Trans i18nKey='to_home' />
            </Button>
          </Link>
        </Box>
      </Stack>
    </Box>
  )
}
